module.exports = __webpack_public_path__ + "static/media/14_720.e332dff7.jpeg";